const styles = (theme) => ({
  payments: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiIcon-root': {
      height: 'auto',
    },
  },
  paymentItem: {
    marginTop: theme.spacing(1),
  },
  cardIcon: {
    fontSize: 30,
    marginRight: theme.spacing(1.25),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  title: {
    opacity: 1,
  },
});

export default styles;
